export default "__VITE_ASSET__CEDruVi1__"